module.exports = __webpack_public_path__ + "img/account-recovery-cover-image.df677fd9.jpg";